export const baseAPI =
  process.env.NODE_ENV === "development"
    ? "https://api-v3-uat.career.support"
    : "https://api-v3.career.support";
// export const baseAPI = "https://api-v3-uat.career.support";
// export const baseAPI = "https://api-v3.career.support";
